export enum ETypNazvu {
    ALTERNATIVE_LANGUAGE_LEGAL_NAME = 'ALTERNATIVE_LANGUAGE_LEGAL_NAME',
    PREVIOUS_LEGAL_NAME = 'PREVIOUS_LEGAL_NAME',
    TRADING_OR_OPERATING_NAME = 'TRADING_OR_OPERATING_NAME'
}
export enum ETypNazvuTrans {
    PREFERRED_ASCII_TRANSLITERATED_LEGAL_NAME = 'PREFERRED_ASCII_TRANSLITERATED_LEGAL_NAME',
    AUTO_ASCII_TRANSLITERATED_LEGAL_NAME = 'AUTO_ASCII_TRANSLITERATED_LEGAL_NAME'
}
